import React, { useEffect, useState } from "react";
import { ColumnDirective, ColumnsDirective, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Select from "react-select";
import Api from "../../Hooks/Api";
import useFetchData from "../../Hooks/useFetchData";
import useValidateRole from "../../Hooks/useValidateRole";
const BankAccounts = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setview] = useState(false);
    const [ViewApprovals, setviewApprovals] = useState(false);
    const [BankAccountsApprovalWorkFlow, setBankAccountsApprovalWorkFlow] = useState([]);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Bank Accounts");
    const Bank = useFetchData("api/Bank");
    const url = "api/BankAccounts";
    const dataurl = process.env.REACT_APP_BASE_URL + 'api/BankAccounts/AllBanks';
    const { state, FetchAll } = useFetch(url);
    const Institutions = useFetchData("api/DashBoard/ApprovedInstitutions");
    const BankBranches = useFetchData("api/bankBranch");
    const InstitutionOptions = [];
    const BankBranchOptions = [];
    if (BankBranches.response) {
        BankBranches.response.map((k, i) => {
            if (k.bankId === inputs.bankId) {
                let col = {
                    value: k.id,
                    label: k.name,
                };
                BankBranchOptions.push(col);
            }

        });
    }
    if (Institutions.response) {
        Institutions.response.map((k, i) => {
            let col = {
                value: k.id,
                label: k.name,
            };
            InstitutionOptions.push(col);
        });
    }
    const StatusOptions = [{ name: "Active" }, { name: "Not Active" }].map((k, i) => {
        return {
            value: k.name.toString(),
            label: k.name.toString()
        };
    });

    useEffect(() => {
        FetchAll();
    }, []);
    const handleOpenModal = (event) => {
        //event.persist();
        setInputs({});
        setOpen(true);
    };
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
    };
    const BankOptions = [];
    if (Bank.response) {
        Bank.response.map((k, i) => {
            let col = {
                value: k.id,
                label: k.name,
            };
            BankOptions.push(col);
        });
    }
    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setview(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setview(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }
    };
    const FetchApprovals = (id) => {
        Api.get("api/BankAccounts/BankAccountsApprovalWorkFlow/" + id)
            .then(function (response) {
                setBankAccountsApprovalWorkFlow(response.data)
            })
            .catch(function (error) {
            })
            .then(function () {
                // always executed
            })

    };
    const handleViewApprovals = () => {
        if (inputs.id) {
            FetchApprovals(inputs.id)
            setviewApprovals(true);
        } else {
            alert("Select a record to veiw");
        }
    };
    const fetchOneBankDetails = (url) => {
        Api.get(url)
          .then(function (response) {
            if (response.data.length > 0) {
              setInputs(response.data[0]);
            }
          })
          .catch(function (error) {
          })
          .then(function () {
            // always executed
          })
      };
    const handleSelect = (k, event) => {
        setInputs({});
        setInputs(k.data);
        fetchOneBankDetails("api/BankAccounts/" + k.data.id);
    };
    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setview(false);
        setUpdate(false);
        setviewApprovals(false)
    };
    const HandleSave = () => {
        useSave(url, inputs);
        setTimeout(() => {
            FetchAll();
        }, 2000)
    };
    const HandleUpdate = () => {
        useUpdate(url + "/" + inputs.id, inputs);
        setTimeout(() => {
            FetchAll();
        }, 2000)

    };
    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }
        setOpen(false);
    };
    const CallDeletehook = () => {
        useDelete(url + "/" + inputs.id);
        setTimeout(() => {
            FetchAll();
        }, 2000)
    };
    const HandelDelete = () => {
        if (inputs.id) {
            CallDeletehook();
        } else {
            alert("Select a record to delete");
        }
    };


    const ActionsBtn = () => {
        return (
            <div>

                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
        </button>
            </div>
        );
    };
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Bank Account</li>
            </ol>
            <h1 class="page-header mb-3">Bank Account</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div class="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                         {useValidateRole(PageRole, "AddNew") &&
                            window.sessionStorage.getItem("securitygroup") === "Institution Administrator" ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleViewApprovals}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View Approvals&nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <GridComponent
                            allowPaging={true}
                            allowResizing={true}
                            allowFiltering={true}

                            rowSelected={(args) => {
                                handleSelect(args);
                            }}
                            dataSource={new DataManager({
                                adaptor: new UrlAdaptor(),
                                crossDomain: true,
                                url: dataurl,
                                headers: [{
                                    Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                                }]
                            })
                            }>
                            <ColumnsDirective>
                                <ColumnDirective field='id' headerText='id' visible={false} />
                                <ColumnDirective field='accountNumber' headerText='Account Number' width='80' />
                                <ColumnDirective field='status' headerText='Status' width='50'  />
                                <ColumnDirective field='approvalStatus' headerText='Approval Status' width='60'  />
                                <ColumnDirective field='institution' headerText='Institution' />
                                <ColumnDirective field='bank' headerText='Bank' width='100' />
                                <ColumnDirective field='accountName' headerText='AccountName' />
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Resize, Filter]} />
                        </GridComponent>
                        {/* <Table Rows={Rowdata1} columns={ColumnData} /> */}
                    </div>
                </div>
            </div>
            <Modal visible={ViewApprovals} width="80%" height="70%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <div class="col-xs-12 left-block">
                        <br />

                        <span className="font-weight-bold">Account No:</span>&nbsp;&nbsp;
                        <span className="font-weight-bold"> {inputs.accountNumber}</span>
                        <br />
                        <span className="font-weight-bold">Account Name:</span>&nbsp;&nbsp;
                        <span className="font-weight-bold"> {inputs.accountName}</span>
                        <br />
                        <span className="font-weight-bold">Status:</span>&nbsp;&nbsp;
                        <span className="font-weight-bold">{inputs.status}</span>
                        <br />
                        <span className="font-weight-bold">Approval Status:</span>&nbsp;&nbsp;
                        <span className="font-weight-bold">{inputs.approvalStatus}</span>
                        <br />
                        <span className="font-weight-bold">Institution:</span>&nbsp;&nbsp;
                         <span className="font-weight-bold">{inputs.institution ? inputs.institution.name : ""}</span>
                        <br />
                    </div>
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-md-12">
                                <table class="table table-striped table-sm" >
                                    <thead>

                                        <tr>
                                            <th scope="col">Status</th>
                                            <th scope="col">DateCreated</th>
                                            <th scope="col">DateofApproval</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Mandatory</th>
                                            <th scope="col">Remarks</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {BankAccountsApprovalWorkFlow.map((k) => {
                                            return (<tr>
                                                <td scope="row">{k.status}</td>
                                                <th >{k.dateCreated}</th>
                                                <th >{k.dateofApproval}</th>
                                                <td>{k.name}</td>
                                                <td>{k.isMandatory ? "Yes" : "No"}</td>
                                                <td>{k.remarks}</td>

                                            </tr>)
                                        })}



                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", "justify-content": "flex-end" }}>
                        <div class="d-flex flex-row">
                            <button style={{ margin: "20px" }}
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                            >
                                Close </button>
                        </div>
                        <br />
                    </div>

                </div>
            </Modal>

            <Modal visible={open} width="65%" height="55%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
          </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 fontWeight-bold text-blue">
                                Bank Account
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Bank Branch</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Institution:</td>
                                                    <td>{inputs.institution ? inputs.institution.name : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>{inputs.accountNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">accountName:</td>
                                                    <td>{inputs.accountName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Bank:</td>
                                                    <td>{inputs.bank ? inputs.bank.name : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Branch:</td>
                                                    <td>{inputs.bankBranch ? inputs.bankBranch.name : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Status:</td>
                                                    <td>{inputs.status}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className=" row">
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Institution</label>
                                                    <div class="col-md-9">
                                                        <Select
                                                            name="institutionId"
                                                            value={InstitutionOptions.filter(
                                                                (option) => option.value === inputs.institutionId
                                                            )}
                                                            //defaultInputValue={inputs.securityGroupId}
                                                            onChange={handleSelectChange}
                                                            options={InstitutionOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Bank</label>
                                                    <div class="col-md-9">
                                                        <Select
                                                            name="bankId"
                                                            value={BankOptions.filter(
                                                                (option) => option.value === inputs.bankId
                                                            )}
                                                            //defaultInputValue={inputs.securityGroupId}
                                                            onChange={handleSelectChange}
                                                            options={BankOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" row">

                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Bank Branch</label>
                                                    <div class="col-md-9">
                                                        <Select
                                                            name="BankBranchId"
                                                            value={BankBranchOptions.filter(
                                                                (option) => option.value === inputs.BankBranchId
                                                            )}
                                                            //defaultInputValue={inputs.securityGroupId}
                                                            onChange={handleSelectChange}
                                                            options={BankBranchOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">AccountNumber</label>
                                                    <div class="col-md-9">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="accountNumber"
                                                            required
                                                            value={inputs.accountNumber}
                                                            onChange={handleInputChange}
                                                        // defaultvalue={inputs.name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" row">

                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Account Name</label>
                                                    <div class="col-md-9">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="accountName"
                                                            required
                                                            value={inputs.accountName}
                                                            onChange={handleInputChange}
                                                        // defaultvalue={inputs.name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Status</label>
                                                    <div class="col-md-9">
                                                        <Select
                                                            name="status"
                                                            value={StatusOptions.filter(
                                                                (option) => option.value === inputs.status
                                                            )}
                                                            //defaultInputValue={inputs.securityGroupId}
                                                            onChange={handleSelectChange}
                                                            options={StatusOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <div class="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                 &nbsp;
                        <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                        </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default BankAccounts;
